import { render } from "./buyDBC.vue?vue&type=template&id=7a3d1e95&scoped=true"
import script from "./buyDBC.vue?vue&type=script&lang=js"
export * from "./buyDBC.vue?vue&type=script&lang=js"

import "./buyDBC.vue?vue&type=style&index=0&id=7a3d1e95&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3d1e95"]])

export default __exports__